import { graphql } from '@/gql/codegen/gql';
import { GET_COURSE_LESSON } from '@/routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/lessons/$lessonSlug/index.route.lazy';
import { useMutation } from '@apollo/client';
import { useCallback, useState } from 'react';

export const ANSWER_PRACTICE_FREE_INPUT_QUESTION_MUTAION =
  graphql(/* GraphQL */ `
  mutation EmbaAnswerPracticeFreeInputQuestion(
    $input: AnswerPracticeFreeInputQuestionMutationInput!
  ) {
    embaAnswerPracticeFreeInputQuestion(input: $input) {
      success
    }
  }
`);

export const ANSWER_PRACTICE_SELECT_QUESTION_MUTAION = graphql(/* GraphQL */ `
  mutation EmbaAnswerPracticeSelectQuestion(
    $input: AnswerPracticeSelectQuestionMutationInput!
  ) {
    embaAnswerPracticeSelectQuestion(input: $input) {
      success
    }
  }
`);

export const useAnswerPracticeQuestionMutations = (
  embaUserAttendanceSlug: string,
  embaCourseLessonSlug: string,
) => {
  const [isAnsweredModalOpen, setIsAnsweredModalOpen] = useState(false);

  const [
    embaAnswerPracticeFreeInputQuestionMutation,
    {
      error: answerPracticeFreeInputQuestionError,
      loading: answerPracticeFreeInputQuestionLoading,
    },
  ] = useMutation(ANSWER_PRACTICE_FREE_INPUT_QUESTION_MUTAION, {
    refetchQueries: [
      {
        query: GET_COURSE_LESSON,
        variables: {
          embaUserAttendanceSlug,
          embaCourseLessonSlug,
        },
      },
    ],
  });

  const answerPracticeFreeInputQuestion = useCallback(
    async (
      embaPracticeFreeInputQuestionId: number,
      embaPracticeFreeInputQuestionAnswerContent: string,
    ): Promise<void> => {
      await embaAnswerPracticeFreeInputQuestionMutation({
        variables: {
          input: {
            embaUserAttendanceSlug,
            embaPracticeFreeInputQuestionId,
            embaPracticeFreeInputQuestionAnswerContent,
            embaCourseLessonSlug,
          },
        },
      });
      setIsAnsweredModalOpen(true);
    },
    [
      embaAnswerPracticeFreeInputQuestionMutation,
      embaUserAttendanceSlug,
      embaCourseLessonSlug,
    ],
  );

  const [
    embaAnswerPracticeSelectQuestionMutation,
    {
      error: answerPracticeSelectQuestionError,
      loading: answerPracticeSelectQuestionLoading,
    },
  ] = useMutation(ANSWER_PRACTICE_SELECT_QUESTION_MUTAION, {
    refetchQueries: [
      {
        query: GET_COURSE_LESSON,
        variables: {
          embaUserAttendanceSlug,
          embaCourseLessonSlug,
        },
      },
    ],
  });

  const answerPracticeSelectQuestion = useCallback(
    async (
      embaPracticeSelectQuestionId: number,
      embaPracticeSelectQuestionAnswerChoiceId: number,
    ): Promise<void> => {
      await embaAnswerPracticeSelectQuestionMutation({
        variables: {
          input: {
            embaUserAttendanceSlug,
            embaPracticeSelectQuestionId,
            embaPracticeSelectQuestionAnswerChoiceId,
            embaCourseLessonSlug,
          },
        },
      });
      setIsAnsweredModalOpen(true);
    },
    [
      embaAnswerPracticeSelectQuestionMutation,
      embaUserAttendanceSlug,
      embaCourseLessonSlug,
    ],
  );

  const closeAnsweredModal = useCallback(() => {
    setIsAnsweredModalOpen(false);
  }, []);

  return {
    answerPracticeFreeInputQuestion,
    answerPracticeFreeInputQuestionError,
    answerPracticeFreeInputQuestionLoading,
    answerPracticeSelectQuestion,
    answerPracticeSelectQuestionError,
    answerPracticeSelectQuestionLoading,
    isAnsweredModalOpen,
    closeAnsweredModal,
  };
};
